export default __webpack_public_path__ + "static/media/about-benefits-home.a4dcdb32.jpg";